<template>
  <b-overlay
    :show="show"
    rounded
    opacity="0.9"
    variant="custom-won"
    spinner-small
    spinner-variant="primary"
    fixed
    class="d-inline-block"
    no-wrap
  >
    <template #overlay>
      <div class="wrap-victory">
        <div class="box-line box-top">
          <img class="img-top" src="~@/assets/icons/line-victory.svg" />
        </div>
        <div class="box-mask">
          <img class="img-mask" src="~@/assets/imgs/victory-mask.png" />
        </div>
        <div class="c-victory">
          <div class="box-title">
            <div class="vic-title">VICTORY</div>
            <div class="vic-desc">You are victorious!</div>
          </div>
          <div class="line-pop"></div>
          <div class="box-reward">
            <div class="re-reward">
              + {{ utils.bigToCommon(reward, 18, 2) }}
              {{ geTitle || "Hash Rate" }}
            </div>
          </div>
          <div class="box-action text-center">
            <b-btn
              class="kuni-btn btn-earn px-5"
              @click.prevent="$emit('onClose')"
            >
              OK
            </b-btn>
          </div>
        </div>
        <div class="box-line box-bottom">
          <img class="img-top" src="~@/assets/icons/line-victory.svg" />
        </div>
      </div>
    </template>
  </b-overlay>
</template>
<script>
export default {
  name: "Victory",
  props: ["show", "reward", "geTitle"],
};
</script>

<style lang="scss" scoped>
.wrap-victory {
  position: relative;
  width: 526px;
  height: 260px;
  margin: auto;
  background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.5) 0%,
      rgba(0, 0, 0, 0.5) 100%
    ),
    linear-gradient(180deg, #17101f 0%, #20132f 23.76%, #482f66 100%);
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 0 20px 2px #17101f;
  .c-victory {
    position: relative;
    z-index: 2;
    .box-title {
      margin-top: -15px;
      .vic-title {
        background: linear-gradient(180deg, #25ffde 13.19%, #00826e 75%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        text-align: center;
        text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        font-family: Bebas Neue;
        font-size: 60px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
      .vic-desc {
        color: #fff;
        text-align: center;
        font-family: Source Sans Pro;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        padding-bottom: 20px;
      }
    }
    .line-pop {
      width: 100%;
      height: 2px;
      background: radial-gradient(circle, #fff 0%, rgba(0, 0, 0, 0) 70%);
    }

    .box-reward {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 21px 76px 8px 76px;
      // border-top: 1px solid rgba(70, 46, 99, 0);
      .re-label {
        color: var(--White, #fff);
        text-align: center;
        font-family: Source Sans Pro;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        margin-right: 16px;
      }
      .re-reward {
        color: var(--Red, #eb345f);
        text-align: center;
        font-family: Bebas Neue;
        font-size: 36px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
    }

    .your-rate {
      color: var(--White, #fff);
      text-align: center;
      font-size: 16px;
      font-style: italic;
      font-weight: 600;
      line-height: normal;
      padding-bottom: 6px;
    }

    .box-action {
      .kuni-btn {
        padding: 12px 30px;
        color: var(--White, #fff);
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        border-radius: 2px;
        border: none;
        &:active,
        &:focus {
          box-shadow: none;
        }
      }
      &.kuni-btn-close {
        background: rgba(147, 147, 147, 0.5);
      }

      .btn-earn {
        background: #eb345f;
      }
    }
  }

  // .box-line {
  //   width: 100%;
  //   top: 52px;
  //   z-index: 99;
  //   display: flex;
  //   justify-content: center;
  //   text-align: center;
  //   position: absolute;
  //   // .img-top {
  //   // background-color: red;
  //   // }
  // }
  .box-line {
    position: relative;
    height: 25px;
    width: 300px;
    margin: 0 auto;
    z-index: 1;
    // background: #25ffde;
    // clip-path: polygon(0 100%, 25px 0, calc(100% - 25px) 0, 100% 100%);
    // &::before {
    //   clip-path: polygon(
    //     3px 100%,
    //     28px 3px,
    //     calc(100% - 28px) 3px,
    //     calc(100% - 3px) 100%
    //   );
    //   content: "";
    //   position: absolute;
    //   inset: 0;
    //   z-index: -1;
    //   background: linear-gradient(
    //       0deg,
    //       rgba(0, 0, 0, 0.5) 0%,
    //       rgba(0, 0, 0, 0.5) 100%
    //     ),
    //     linear-gradient(180deg, #17101f 0%, #20132f 23.76%, #482f66 100%);
    // }
    &.box-top {
      top: -14px;
    }

    &.box-bottom {
      bottom: -8px;
      transform: rotate(180deg);
      // clip-path: polygon(0 100%, 25px 0, calc(100% - 25px) 0, 100% 100%);
      // &::before {
      //   clip-path: polygon(
      //     3px 100%,
      //     28px 3px,
      //     calc(100% - 28px) 3px,
      //     calc(100% - 3px) 100%
      //   );
      //   content: "";
      //   position: absolute;
      //   inset: 0;
      //   z-index: -1;
      //   background: #231731;
      // }
    }
  }
  .box-mask {
    .img-mask {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      z-index: 1;
      top: -10px;
    }
  }
  @media (max-width: 767px) {
    width: 430px;
  }
  @media (max-width: 450px) {
    width: 320px;
    height: 264px;
    .c-victory {
      .box-reward {
        padding: 18px 30px;
      }
      .box-title .vic-title {
        font-size: 50px;
      }
      .box-reward .re-label {
        font-size: 18px;
      }
    }
    .box-line {
      width: 230px;
      &.box-top {
        top: -16px;
      }
      &.box-bottom {
        bottom: -16px;
      }
      img {
        width: 100%;
      }
    }
    .box-mask {
      .img-mask {
        width: 230px;
      }
    }
  }
}
</style>
